module.exports = __webpack_public_path__ + "static/media/atol-einwetok.18fe8c2f.jpg";